import React, { forwardRef, PropsWithChildren } from 'react';
import classNames from 'classnames';
import { InputGroup, InputGroupAddon } from '../input-group';
import { CSSValueWithLength } from '../../styles';
import { InputSize, InputStatus } from './types';

export interface InputAffixProps {
  className?: string;
  width?: CSSValueWithLength;
  flex?: React.CSSProperties['flex'];
  disabled?: boolean;
  status?: InputStatus;
  /** @default 'medium' */
  size?: InputSize;
  /** Input 좌측에 렌더링될 요소 */
  prefix?: string;
  /** Input 우측에 렌더링될 요소 */
  suffix?: string;
}

/**
 * prefix/suffix가 있는 `Input`을 하나의 필드로 묶는다.
 *
 * `InputGroup`을 `full` 구분선으로 렌더해서 PDS 1.0의 박스형 애드온 표현을 유지한다.
 * 이 컴포넌트가 다른 `InputGroup` 안에 들어가면 부모의 구분선 방식을 따라가므로,
 * 그룹 안에서는 자동으로 PDS 2.0 표현이 된다.
 */
export const InputAffix = forwardRef<HTMLDivElement, PropsWithChildren<InputAffixProps>>(
  ({ className, children, prefix, suffix, width, flex, disabled, status = 'info', size }, ref) => {
    return (
      <InputGroup
        dividerVariant='full'
        _unstable_inheritsDividerVariant
        className={classNames('pds-input-affix', className)}
        size={size}
        status={status === 'error' ? 'error' : undefined}
        disabled={disabled}
        width={width ?? '100%'}
        flex={flex}
        ref={ref}
      >
        {prefix && <InputGroupAddon className='pds-input-addon left'>{prefix}</InputGroupAddon>}
        {children}
        {suffix && <InputGroupAddon className='pds-input-addon right'>{suffix}</InputGroupAddon>}
      </InputGroup>
    );
  },
);

InputAffix.displayName = 'InputAffix';
